import React from 'react';

/**
 * "Skip to main content" link for keyboard / screen-reader users.
 *
 * Visually hidden until focused. When activated, jumps focus past the sidebar
 * and top nav directly to <main id="main-content">. WCAG 2.4.1.
 *
 * Mount once at the top of App.js. Pair with id="main-content" on the <main>.
 */
const SkipToContent = () => (
  <a
    href="#main-content"
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      padding: '8px 16px',
      background: 'var(--primary-color, #22489E)',
      color: '#fff',
      fontWeight: 700,
      textDecoration: 'none',
      borderRadius: '0 0 8px 0',
      // Hide off-screen until focused.
      transform: 'translateY(-100%)',
      transition: 'transform 0.15s ease',
      zIndex: 9999,
    }}
    onFocus={(e) => { e.currentTarget.style.transform = 'translateY(0)'; }}
    onBlur={(e) => { e.currentTarget.style.transform = 'translateY(-100%)'; }}
  >
    Skip to main content
  </a>
);

export default SkipToContent;
